(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("point-cloud-intersecting-volumes", [], factory);
	else if(typeof exports === 'object')
		exports["point-cloud-intersecting-volumes"] = factory();
	else
		root["point-cloud-intersecting-volumes"] = factory();
})(self, function() {
return 